import React, { useState, useEffect } from "react";
import qs from "query-string";

import { Page, PendingButton } from "components/common";
import { ApiClient } from "services";
import { Trans } from "react-i18next";

export const Connect = ({ location }) => {
  const [client] = useState(() => ApiClient());
  const [data, setData] = useState(null);
  const [disconnecting, setDisconnecting] = useState(false);
  const url = "xero_connections";
  const { search } = location;

  useEffect(
    () =>
      (async () => {
        const { code } = qs.parse(search);

        if (code) {
          await client.post(`${url}/confirm_connection`, {
            uri: window.location.href,
          });
          window.location.replace("/connect");
        } else {
          const data = await client.get("xero_connections").get("data");
          setData(data);
        }
      })(),
    []
  );

  const onDisconnect = async () => {
    setDisconnecting(true);
    await client.get(`/xero_connections/disconnect`);
    window.location.replace("/connect");
  };

  const base = (children) => <Page title="Xero Connect">{children}</Page>;

  if (!data) return base(<Trans>Loading...</Trans>);

  return base(
    data.connected ? (<div className="text-center">
        <h4 className="p-2">
          <Trans>Connected to {data.xero_organisation_name}</Trans>
        </h4>
        <PendingButton
          color="danger"
          onClick={onDisconnect}
          pending={disconnecting}
        >
          Disconnect
        </PendingButton>
      </div>
    ) : (
      <a href={data.url} className="btn btn-primary">
        <Trans>Connect Xero</Trans>
      </a>
    )
  );
};
